module.exports = __webpack_public_path__ + "media/flags/020-flag-1566642f.svg";